import { Component, ojs, app, payload, State } from "modular-openscriptjs";
import { dom, tool } from "../../fotastart";
import {
    fireEvent,
    monetary,
    empty,
    either,
    setCurrentLocationCoordinates,
    inform,
} from "../../helpers";
import Collapse from "../Blocks/Collapse";
import SolidIcon from "../Blocks/SolidIcon";
import { $e } from "../../ojs.events";
import { api, STRINGS } from "../../declarations";
import { routes } from "../../backendRoutes";
import Spinner, { SmallSpinner } from "../Blocks/Spinner";

const h = app("h");
const broker = app("broker");
const gc = app("gc");
const dc = app("dc");
const router = app("router");

ojs(Collapse, SolidIcon, Collapse, Spinner, SmallSpinner);

export default class OrderDetails extends Component {
    render(orderState, user, ...args) {
        const order = orderState.value;
        let fillUpPrices = 0;
        let pickUpContainer = 0;

        if (user?.settings && user?.settings.length > 0) {
            for (let setting of user?.settings) {
                if (setting.setting == "fill_up_prices") {
                    fillUpPrices = setting.setting_value ?? setting.value;
                } else if (setting.setting == "pickup_food_container") {
                    pickUpContainer = setting.setting_value ?? setting.value;
                }
            }
        }

        return h.div(
            h.div(
                { class: "d-flex flex-column gap-3 py-2" },

                // Header Card: Status, Delivery Type, Code, and Prices
                h.div(
                    {
                        class: "card border-0 bg-light p-3 rounded-4 mb-2 shadow-sm",
                    },
                    h.div(
                        {
                            class: "d-flex align-items-center justify-content-between mb-2",
                        },
                        h.div(
                            { class: "d-flex gap-2 align-items-center" },
                            h.span(
                                {
                                    class: "badge rounded-pill fw-bold px-3 py-1.5",
                                },
                                order?.status,
                                window.getStatusClass
                                    ? window.getStatusClass(order?.status)
                                    : "",
                            ),
                            either(
                                order?.type === "delivery_request" ||
                                    order?.delivery_request_id,
                                () =>
                                    h.span(
                                        {
                                            class: "badge bg-info-subtle text-info border border-info-subtle rounded-pill px-3 py-1.5 fw-bold",
                                        },
                                        "Delivery Request",
                                    ),
                            ),
                        ),
                        h.span(
                            {
                                class: "text-muted fs-xsm fw-bold text-uppercase",
                            },
                            `#${order?.order_code || ""}`,
                        ),
                    ),
                    h.div(
                        {
                            class: "d-flex justify-content-between align-items-end mt-2 pt-2 border-top border-light-subtle",
                        },
                        either(
                            order?.type === "delivery_request" ||
                                order?.delivery_request_id,
                            () =>
                                h.div(
                                    h.span(
                                        {
                                            class: "text-secondary fs-xsm d-block mb-1 text-uppercase fw-bold",
                                        },
                                        "Delivery Fee:",
                                    ),
                                    h.span(
                                        { class: "fs-4 fw-bold text-primary" },
                                        monetary(
                                            order?.total_delivery_price ?? 0,
                                        ),
                                    ),
                                ),
                            () => [
                                h.div(
                                    h.span(
                                        {
                                            class: "text-secondary fs-xsm d-block mb-1 text-uppercase fw-bold",
                                        },
                                        "Order Amount:",
                                    ),
                                    h.span(
                                        { class: "fs-4 fw-bold text-dark" },
                                        monetary(order?.total_price ?? 0),
                                    ),
                                ),
                                either(order?.total_delivery_price > 0, () =>
                                    h.div(
                                        { class: "text-end" },
                                        h.span(
                                            {
                                                class: "text-secondary fs-xsm d-block mb-1 text-uppercase fw-bold",
                                            },
                                            "Delivery Fee:",
                                        ),
                                        h.span(
                                            {
                                                class: "fs-5 fw-bold text-primary",
                                            },
                                            monetary(
                                                order?.total_delivery_price ??
                                                    0,
                                            ),
                                        ),
                                    ),
                                ),
                            ],
                        ),
                    ),
                ),

                // Request Price Top-up link (Not prominent) - Hidden for delivery requests
                either(
                    order?.type !== "delivery_request" &&
                        !order?.delivery_request_id,
                    () =>
                        h.div(
                            { class: "d-flex justify-content-start my-1" },
                            h.span(
                                {
                                    class: "text-muted text-decoration-underline fs-sm",
                                    style: "cursor: pointer; font-size: 0.85rem;",
                                    onclick: this.method(
                                        "createPaymentRequest",
                                        [order?.id, "purchase"],
                                    ),
                                },
                                "Request Price Top-up",
                            ),
                        ),
                ),

                // Order Notes (Prominent Callout)
                either(!empty(order?.notes), () =>
                    h.div(
                        {
                            class: "alert alert-warning border-start border-warning border-4 d-flex gap-2 align-items-start p-3 my-1 rounded-3 shadow-sm",
                            style: "border-left-width: 5px !important;",
                        },
                        h.i({
                            class: "bi bi-exclamation-triangle-fill text-warning fs-5 mt-1",
                        }),
                        h.div(
                            h.strong(
                                { class: "d-block text-warning-emphasis mb-1" },
                                "Important Order Notes:",
                            ),
                            h.span(
                                { class: "text-dark-emphasis" },
                                order?.notes,
                            ),
                        ),
                    ),
                ),

                // Get Direction Button (below notes)
                h.call(() => {
                    if (empty(order.delivery_waypoints)) return null;

                    setCurrentLocationCoordinates(true, null, true);

                    if (empty(dc.latitude)) return null;

                    return h.button(
                        {
                            class: "btn btn-white border rounded-3 text-primary d-flex align-items-center justify-content-center gap-2 w-100 py-2.5 fs-6 shadow-sm mt-1",
                            onclick: this.method("openPurchaseRoute", [
                                order.delivery_waypoints,
                                order.delivery_address?.latitude,
                                order.delivery_address?.longitude,
                            ]),
                        },
                        h.i({ class: "bi bi-signpost-2 fs-5" }),
                        h.span("Get Directions"),
                    );
                }),

                // Extra Alerts
                either(
                    fillUpPrices == 1,
                    h.div(
                        {
                            class: "alert alert-info border-start border-info border-4 p-3 rounded-3",
                        },
                        `Do not call ${user?.first_name} when prices are different. Just purchase the items, they will pay back on delivery.`,
                    ),
                ),

                either(
                    pickUpContainer == 1,
                    h.div(
                        {
                            class: "alert alert-info border-start border-info border-4 p-3 rounded-3",
                        },
                        `Please pickup ${user?.first_name} food container(s) from their delivery address if there's food item in the order.`,
                    ),
                ),

                // Delivery / Payment collection / Completion Code flow (Important to deliverer)
                either(
                    order?.status == "delivering" &&
                        order?.total_paid >=
                            (order?.total_delivery_price ?? 0) +
                                (order?.total_price ?? 0),
                    () => [
                        h.div(
                            {
                                class: "d-flex justify-content-between gap-3 my-2",
                            },

                            h.button(
                                {
                                    class: "btn btn-outline-dark d-flex gap-2 align-items-center justify-content-center flex-grow-1 py-2",
                                    type: "button",
                                    id: "timer",
                                    onclick: this.method("letCustomerKnow", [
                                        "${this}",
                                        order.id,
                                    ]),
                                },
                                h.i({ class: "bi bi-bell fs-5" }),
                                h.span("I'm waiting"),
                            ),
                        ),
                    ],
                ),

                either(
                    order?.status == "delivering" &&
                        order?.total_paid <
                            (order?.total_delivery_price ?? 0) +
                                (order?.total_price ?? 0),
                    () =>
                        h.div(
                            {
                                class: "d-flex gap-2 flex-column my-2 p-3 bg-light border rounded-3",
                            },
                            h.call(() => {
                                const amount =
                                    (order?.total_delivery_price ?? 0) +
                                    (order?.total_price ?? 0) -
                                    (order?.total_paid ?? 0);

                                return [
                                    h.div(
                                        {
                                            class: "d-flex justify-content-between align-items-center mb-2",
                                        },
                                        h.span(
                                            { class: "fs-6 text-muted" },
                                            "Total Amount Owed:",
                                        ),
                                        h.span(
                                            {
                                                class: "fs-5 fw-bold text-danger",
                                            },
                                            monetary(amount),
                                        ),
                                    ),
                                    h.button(
                                        {
                                            class: "btn btn-dark d-flex gap-2 justify-content-center align-items-center py-2",
                                            onclick: this.method("getPayment", [
                                                order?.id,
                                                amount,
                                            ]),
                                        },
                                        h.i({ class: "bi bi-cash-stack fs-5" }),
                                        h.span("Collect Payment"),
                                    ),
                                ];
                            }),
                        ),
                ),
            ),

            either(
                !(order?.status in { completed: true, cancelled: true }),
                () =>
                    h.div(
                        {
                            class: "d-flex gap-3 align-items-center justify-content-between my-3",
                        },
                        either(
                            order?.previous_status &&
                                Object.keys(order.previous_status).length > 0,
                            () =>
                                this.renderMovementButton(
                                    order.previous_status,
                                    "previous",
                                    order.id,
                                ),
                            h.div({ style: "width: 44px; height: 44px;" }),
                        ),
                        h.span(
                            {
                                class: "fw-bold text-secondary text-uppercase fs-xsm",
                                style: "letter-spacing: 0.05em;",
                            },
                            "Move Order",
                        ),
                        either(
                            order?.next_status &&
                                Object.keys(order.next_status).length > 0,
                            () =>
                                this.renderMovementButton(
                                    order.next_status,
                                    "next",
                                    order.id,
                                ),
                            h.div({ style: "width: 44px; height: 44px;" }),
                        ),
                    ),
            ),

            ...args,
        );
    }

    async openPurchaseRoute(waypoints, latitude, longitude) {
        let url = `https://www.google.com/maps/dir/${dc.latitude},${dc.longitude}/`;

        if (!empty(waypoints)) {
            for (let purchasePosition of waypoints) {
                let coord = purchasePosition.position;

                url += `${coord.latitude},${coord.longitude}/`;
            }
        }

        url += `${latitude},${longitude}/`;

        let a = h.a({ href: url, target: "_blank" });
        a.click();

        return;
    }

    createPaymentRequest(orderId, purpose) {
        broker.send(
            $e.paymentRequest.needs.creation,
            payload({ request: { purpose, orderId } }),
        );
    }

    letCustomerKnow(button, orderId) {
        broker.send($e.deliverer.has.arrived, payload({ orderId }));
        dom.disable(button);

        const delivererWaitTime = window.delivererWaitTime ?? 300000;
        this.startTimer(delivererWaitTime, button, orderId);

        setTimeout(() => {
            button.disabled = false;
            dom.put("You can leave", button);
            button.classList.remove("btn-info");
            button.classList.add("btn-danger");
        }, delivererWaitTime);
    }

    startTimer(duration, element, orderId) {
        const startTimeKey = `startTime_${orderId}`;

        const storedStartTime = parseInt(
            localStorage.getItem(startTimeKey),
            10,
        );
        const startTime = storedStartTime || Date.now();
        localStorage.setItem(startTimeKey, startTime.toString());

        function updateTimer() {
            const elapsedTime = Date.now() - startTime;
            const remainingTime = Math.max(0, duration - elapsedTime);

            const minutes = Math.floor(remainingTime / (1000 * 60));
            const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
            dom.put(
                `${minutes}:${seconds.toString().padStart(2, "0")}`,
                element,
            );

            if (remainingTime <= 0) {
                clearInterval(timerId);
                localStorage.removeItem(startTimeKey);
            }
        }

        const timerId = setInterval(updateTimer, 1000);
    }

    getPayment(orderId, amount) {
        fireEvent($e.order.needs.to.close.processForm);

        broker.send(
            $e.order.needs.payment,

            payload(
                {
                    orderId: orderId,
                    amount,
                    editable: true,
                    initiator: "deliverer",
                },
                { next: router.current() },
            ),
        );
    }

    computeSurplus(orderId) {
        broker.send($e.order.needs.surplusComputation, payload({ orderId }));
    }

    getStatusButtonClass(status) {
        const st = status?.toLowerCase();
        switch (st) {
            case "dispute":
                return "btn-danger text-white";
            case "confirmed":
                return "btn-secondary text-white";
            case "processing":
                return "btn-primary text-white";
            case "ready":
                return "btn-info text-white";
            case "delivering":
                return "btn-warning text-dark";
            case "completed":
                return "btn-success text-white";
            case "cancelled":
                return "btn-dark text-white";
            default:
                return "btn-primary text-white";
        }
    }

    getStatusButtonStyle(status) {
        const st = status?.toLowerCase();
        if (st === "processing") {
            return "background: linear-gradient(135deg, #0d6efd, #0a58ca);";
        }
        return "";
    }

    renderMovementButton(info, type, orderId, ...args) {
        if (!info || Object.keys(info).length == 0)
            return h.div({ style: "width: 44px; height: 44px;" });

        switch (type) {
            case "next": {
                const statusClass = this.getStatusButtonClass(info.name);
                const statusStyle = this.getStatusButtonStyle(info.name);

                return h.button(
                    {
                        class: `btn ${statusClass} circle shadow-sm p-2 d-flex align-items-center justify-content-center border-0`,
                        style: `width: 44px; height: 44px; min-width: 44px; ${statusStyle}`,
                        title: info.name,
                        onclick: this.method("changeStatus", [
                            orderId,
                            info.url,
                            "next",
                        ]),
                    },
                    h.i({ class: "bi bi-chevron-right fw-bold fs-5" }),
                );
            }
            case "previous": {
                return h.button(
                    {
                        class: "btn btn-white border circle shadow-sm p-2 d-flex align-items-center justify-content-center",
                        style: "width: 44px; height: 44px; min-width: 44px;",
                        title: info.name,
                        onclick: this.method("changeStatus", [
                            orderId,
                            info.url,
                            "previous",
                        ]),
                    },
                    h.i({ class: "bi bi-chevron-left fw-bold fs-5" }),
                );
            }
        }
    }

    changeStatus(orderId, url, stage) {
        if (url == null) return;

        broker.send(
            $e.order.needs.statusChange,
            payload({ orderId, url, stage }),
        );
    }
}

export class CustomerDetails extends Component {
    render(user, orderCode, ...args) {
        return h.$(
            h.div(
                h.small({ class: "fw-bold text-tiny" }, "Name: "),
                h.p(
                    { class: "text" },
                    h.span(user?.first_name, " ", user?.last_name),
                ),
                h.small({ class: "fw-bold text-tiny" }, "Phone: "),
                h.p(
                    {
                        class: "text",
                        onclick: `tool.toClipboard('${user?.phone}')`,
                    },
                    h.span(user?.phone),
                ),
                h.small({ class: "fw-bold text-tiny" }, "Email: "),
                h.p(
                    {
                        class: "text",
                        onclick: `tool.toClipboard('${user?.email}')`,
                    },
                    h.span(user?.email),
                ),
                h.div(
                    {
                        class: "d-flex gap-3 align-items-center justify-content-between pt-3 border-top",
                    },
                    h.a(
                        {
                            class: "d-flex gap-2 align-items-center text-primary",
                            href: `tel:${
                                user?.phone && user?.phone[0] != "+"
                                    ? "+" + user?.phone
                                    : user?.phone
                            }`,
                        },
                        h.i({ class: "fas fa-phone" }),
                        h.span("Call"),
                    ),
                    h.a(
                        {
                            class: "d-flex gap-2 align-items-center text-success",
                            target: "_blank",
                            href: `https://api.whatsapp.com/send?phone=${
                                user?.phone && user?.phone[0] != "+"
                                    ? "+" + user?.phone
                                    : user?.phone
                            }&text=Hi, I am ${
                                gc.user.first_name
                            } From Carata. I am texting regarding order with code: ${orderCode}`,
                        },
                        h.i({ class: "fa-brands fa-whatsapp" }),
                        h.span("WhatsApp"),
                    ),
                    h.span(
                        {
                            class: "d-flex gap-2 align-items-center text-dark",
                        },
                        h.i({ class: "far fa-message" }),
                        h.span("SMS"),
                    ),
                ),
                ...args,
            ),
        );
    }
}

export class OrderDeliveryAddress extends Component {
    render(address, orderCode, ...args) {
        const hasNotes = !empty(address?.additional_information);
        const recipientName = address?.recipient_name ||
            `${address?.first_name || ""} ${address?.last_name || ""}`.trim() ||
            "Recipient";
        
        const phone = address?.phone || "";
        const formattedPhone = phone && phone[0] !== "+" ? "+" + phone.replace(/\D/g, '') : phone;
        const addressText = address?.address || "Unknown Address";

        return h.div(
            // Recipient Section
            h.div(
                { class: "mb-4" },
                h.small({ class: "text-muted text-uppercase fw-bold d-block mb-1", style: "font-size: 10px; letter-spacing: 0.05em;" }, "Recipient"),
                h.div({ class: "fw-bold text-dark fs-5" }, recipientName)
            ),

            // Quick Action Buttons (Call & WhatsApp)
            either(phone, () => h.div(
                { class: "d-flex gap-3 mb-4" },
                h.a(
                    {
                        href: `tel:${formattedPhone}`,
                        class: "btn btn-light border d-flex align-items-center justify-content-center gap-2 rounded-3 py-2.5 flex-grow-1 text-decoration-none text-dark fw-semibold fs-sm transition-all hover-light",
                        style: "background-color: var(--btn-bg, #f2f3f6); border-color: var(--btn-bdr, #dcdfe8);",
                        onclick: "event.stopPropagation();"
                    },
                    h.i({ class: "bi bi-telephone-fill text-primary" }),
                    "Call Recipient"
                ),
                h.a(
                    {
                        href: `https://wa.me/${formattedPhone.replace('+', '')}?text=Hi, I am texting regarding order #${orderCode}`,
                        class: "btn btn-light border d-flex align-items-center justify-content-center gap-2 rounded-3 py-2.5 flex-grow-1 text-decoration-none text-dark fw-semibold fs-sm transition-all hover-light",
                        style: "background-color: var(--btn-bg, #f2f3f6); border-color: var(--btn-bdr, #dcdfe8);",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        onclick: "event.stopPropagation();"
                    },
                    h.i({ class: "bi bi-whatsapp text-success" }),
                    "WhatsApp"
                )
            )),

            // Location / Address Details
            h.div(
                { class: "mb-4" },
                h.small({ class: "text-muted text-uppercase fw-bold d-block mb-2", style: "font-size: 10px; letter-spacing: 0.05em;" }, "Delivery Location"),
                h.p({ class: "text-dark mb-0 fs-sm fw-medium lh-base text-wrap" }, addressText)
            ),

            // Order Notes / Additional Information
            either(hasNotes, () =>
                h.div(
                    {
                        class: "mb-4 p-3 bg-warning-subtle text-warning-emphasis rounded-3 border border-warning-subtle",
                    },
                    h.small(
                        { class: "fw-bold fs-xsm text-uppercase d-block mb-1" },
                        "Order Notes / Instructions",
                    ),
                    h.p(
                        { class: "mb-0 fs-sm" },
                        address.additional_information,
                    ),
                ),
            ),

            // Open in Google Maps Button
            h.a(
                {
                    href: `https://maps.google.com/?q=${address?.latitude},${address?.longitude} (${address?.address})`,
                    target: "_blank",
                    class: "btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2 rounded-3 py-2.5 fw-semibold border-0",
                    style: "background: linear-gradient(135deg, #0d6efd, #0a58ca); box-shadow: 0 4px 12px rgba(13, 110, 253, 0.15);"
                },
                h.i({ class: "bi bi-map-fill" }),
                "Open in Google Maps"
            ),
            ...args,
        );
    }
}

export class AssignedDeliverer extends Component {
    render(user, order, ...args) {
        const unit = order?.fulfilmentUnit || order?.fulfilment_unit;
        const deliverer = unit?.deliverer;
        const purchaseCoordinator =
            unit?.purchaseCoordinator || unit?.purchase_coordinator;

        return h.div(
            { class: "show" },
            either(
                unit,
                () => [
                    h.div(
                        { class: "row g-3 mb-3" },
                        h.div(
                            { class: "col-12" },
                            h.small(
                                {
                                    class: "fw-bold text-tiny text-muted text-uppercase",
                                },
                                "Fulfilment Unit: ",
                            ),
                            h.h5(
                                { class: "fw-bold text-dark mb-0 mt-1" },
                                unit?.name || "N/A",
                            ),
                        ),
                    ),

                    h.div(
                        { class: "border rounded-3 p-3 mb-3 bg-white" },
                        h.small(
                            {
                                class: "fw-bold text-tiny text-muted text-uppercase",
                            },
                            "Deliverer Name: ",
                        ),
                        h.p(
                            { class: "text fw-semibold mb-2 fs-6 text-dark" },
                            deliverer
                                ? h.span(
                                      deliverer?.first_name,
                                      " ",
                                      deliverer?.last_name,
                                  )
                                : h.span(
                                      { class: "text-muted fst-italic" },
                                      "Not Assigned",
                                  ),
                        ),
                        either(deliverer, () =>
                            this.renderContactButtons(deliverer, "Deliverer"),
                        ),
                    ),

                    h.div(
                        { class: "border rounded-3 p-3 mb-3 bg-white" },
                        h.small(
                            {
                                class: "fw-bold text-tiny text-muted text-uppercase",
                            },
                            "Purchase Coordinator Name: ",
                        ),
                        h.p(
                            { class: "text fw-semibold mb-2 fs-6 text-dark" },
                            purchaseCoordinator
                                ? h.span(
                                      purchaseCoordinator?.first_name,
                                      " ",
                                      purchaseCoordinator?.last_name,
                                  )
                                : h.span(
                                      { class: "text-muted fst-italic" },
                                      "Not Assigned",
                                  ),
                        ),
                        either(purchaseCoordinator, () =>
                            this.renderContactButtons(
                                purchaseCoordinator,
                                "Coordinator",
                            ),
                        ),
                    ),

                    either(
                        order?.status === "delivering" ||
                            order?.status === "processing" ||
                            order?.status === "ready",

                        h.div(
                            { class: "d-flex justify-content-end" },

                            h.div(
                                {
                                    class: "btn btn-outline-primary rounded-pill px-4",
                                    onclick: this.method("transfer", [
                                        order.id,
                                        "${this}",
                                    ]),
                                },
                                "Transfer Order",
                            ),
                        ),

                        "",
                    ),
                ],
                () =>
                    h.div(
                        { class: "text-danger text-center mt-2" },
                        h.i({ class: "fas fa-circle-exclamation" }),
                        " No fulfilment unit assigned",
                    ),
            ),
            ...args,
        );
    }

    renderContactButtons(person, roleName) {
        if (!person) return h.empty();
        const phone = person?.phone;
        const formattedPhone = phone && phone[0] !== "+" ? "+" + phone : phone;

        return h.div(
            {
                class: "d-flex gap-3 align-items-center justify-content-between pt-2 border-top mt-2",
            },
            h.a(
                {
                    class: "d-flex gap-2 align-items-center text-primary text-decoration-none small fw-semibold",
                    href: `tel:${formattedPhone}`,
                },
                h.i({ class: "fas fa-phone" }),
                h.span("Call"),
            ),
            h.a(
                {
                    class: "d-flex gap-2 align-items-center text-success text-decoration-none small fw-semibold",
                    href: `https://api.whatsapp.com/send?phone=${formattedPhone}&text=Hi, I am ${
                        gc.user?.value?.first_name || ""
                    } regarding order.`,
                    target: "_blank",
                },
                h.i({ class: "fa-brands fa-whatsapp" }),
                h.span("WhatsApp"),
            ),
            h.span(
                {
                    class: "d-flex gap-2 align-items-center text-dark small",
                },
                h.i({ class: "far fa-message" }),
                h.span("SMS"),
            ),
        );
    }

    async transfer(orderId, btn) {
        dom.disable(btn);
        h.SmallSpinner({ parent: btn, resetParent: true });

        let res = await api.get(
            `riders/${routes.orders}/${orderId}/assignable-fulfilment-units`,
        );

        dom.enable(btn);
        dom.put("Transfer Order", btn);

        if (!res) return;

        let units = res.data.units;

        let options = new tool.ModalOptions();
        options.buttons.right.text = "Transfer";
        options.buttons.left.text = "Close";
        options.classes.buttons.right = "btn btn-success";
        options.buttons.right.closeOnClick = true;

        options.buttons.right.callback = () => {
            let unitId = document.getElementById(
                "available-fulfilment-units",
            ).value;

            if(empty(unitId)) { 
                inform("Please select a fulfilment unit to transfer the order to.", STRINGS.INFO);
                return;
            }


            broker.send(
                $e.deliverer.needs.to.transferOrder,
                payload({
                    order: orderId,
                    fulfilmentUnit: unitId,
                }),
            );
        };

        tool.modal(
            "Order Transfer",
            h.div(
                { class: "text-primary" },
                h.div(
                    {
                        class: "form-text text-primary mb-2",
                    },
                    "Choose who to transfer the order to",
                ),
                h.select(
                    { class: "form-select", id: "available-fulfilment-units" },
                    h.option({ value: "" }, "Select Fulfilment Unit"),
                    each(units, (unit) =>
                        h.option({ value: unit.id }, unit.name),
                    ),
                ),
            ),
            options,
        );
    }
}

ojs(CustomerDetails, OrderDeliveryAddress, AssignedDeliverer);
